import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../control/Button";
import { Dialog } from "./Dialog";

/**
 * Yes/no dialog. The three render confirmations and the delete use it: the
 * confirm button carries the consequence ("Render 6 chapters for $31.91").
 */
export function ConfirmDialog({
  open,
  title,
  children,
  confirmLabel,
  cancelLabel,
  tone = "primary",
  busy = false,
  onConfirm,
  onCancel,
}: {
  open: boolean;
  title: ReactNode;
  children: ReactNode;
  confirmLabel?: ReactNode;
  cancelLabel?: ReactNode;
  tone?: "primary" | "danger";
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const { t } = useTranslation("components");
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      title={title}
      width="sm"
      dismissable={!busy}
      footer={
        <>
          <Button variant="secondary" onClick={onCancel} disabled={busy}>
            {cancelLabel ?? t("confirm.cancel")}
          </Button>
          <Button variant={tone} onClick={onConfirm} busy={busy}>
            {confirmLabel ?? t("confirm.confirm")}
          </Button>
        </>
      }
    >
      {children}
    </Dialog>
  );
}
